import { Typography } from "@material-ui/core";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CommonUtil from "../../Util/CommonUtils";
import USA_visLogo from "../../assets/USA_Images/login_images/App-logo.svg";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT } from "../../actions/EndPoints";

function ChecklistForm(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [visit, setVisit] = useState({});
  const [visitor, setVisitor] = useState({});
  const [checkListItems, setCheckListItems] = useState([]);
  const [ndaUrl, setNdaUrl] = useState(null);
  const [status, setStatus] = useState(location.state.status);
  const [checkListAnswers, setCheckListAnswers] = useState([]);
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [checkExpertedAnswers, setCheckExpertedAnswers] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setCheckListItems(props.location.state.listValue);
    window.history.forward();

    const checkListQuestions = props.location.state.listValue.map((data) => ({
      Question: data.question,
      Answers: "",
    }));

    setCheckListAnswers(checkListQuestions);
    setStatus(props.location.state.status);
    setIsLoading(false);
  }, []);

  const stripHtml = (str) =>
    typeof str === "string" ? str.replace(/<[^>]*>/g, "").trim() : str;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCheckListAnswers((prev) =>
      prev.map((question) =>
        question.Question === name
          ? { ...question, Answers: stripHtml(value) }
          : question,
      ),
    );
  };

  const handleCancel = () => {
    httpCommon
      .unsecuredAxios()
      .put("/web/visit/reject/" + props.location.state.code)
      .then((res) => {
        if (res.data.code === "CVAI0073") {
          history.push({ pathname: "/vis/cancel/Visit" });
        } else {
          Toast(res.data.message, "error");
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setIsLoading(true);
  };

  const handleSubmit = () => {
    setIsLoading(true);
    let error = false;
    let isAnswersMatched = false;

    checkListItems.forEach((question) => {
      if (error) return;
      checkListAnswers.forEach((expertedAnswer) => {
        if (question.question === expertedAnswer.Question) {
          if (
            question.mandatory !== "No" &&
            CommonUtil.isEmpty(expertedAnswer.Answers)
          ) {
            Toast("Please answer mandatory questions", "error");
            setIsLoading(false);
            error = true;
          }
        }
      });
    });

    if (error) return;

    checkListItems.forEach((question) => {
      if (isAnswersMatched) return;
      checkListAnswers.forEach((expertedAnswer) => {
        if (
          question.mandatory === "Yes" &&
          question.question === expertedAnswer.Question
        ) {
          if (!(status === "CONFIRMED" || status === "REJECTED")) {
            const expected = String(question.expertedAnswer || "")
              .toLowerCase()
              .trim();
            const actual = String(expertedAnswer.Answers || "")
              .toLowerCase()
              .trim();
            if (expected !== actual) {
              Toast("CheckList is not as expected", "error");
              handleCancel();
              isAnswersMatched = true;
            }
          } else {
            history.push("/vis/result-page");
          }
        }
      });
    });

    if (isAnswersMatched) return;

    setIsLoading(true);

    const cleanedAnswers = checkListAnswers.map((a) => ({
      Question: a.Question,
      Answers: stripHtml(a.Answers || ""),
    }));

    const payload = {
      visitId: props.location.state.id,
      answers: cleanedAnswers,
    };

    if (
      !(status === "CONFIRMED" || status === "REJECTED") &&
      !props.location.state.ndaEnabled &&
      !props.location.state.videoAcknowledgement
    ) {
      httpCommon
        .unsecuredAxios()
        .post("/web/questionariesAnswer", payload)
        .then((res) => {
          setIsLoading(true);
          const data = res.data;
          if (data.code === "CVHQI0000") {
            httpCommon
              .unsecuredAxios()
              .put("/web/visit/confirm/" + props.location.state.code)
              .then((res) => {
                if (res.data.code === "CVAI0072") {
                  setIsLoading(true);
                  history.push({
                    pathname: "/vis/visit-success",
                    state: { message: res.data.message, success: true },
                  });
                } else {
                  Toast(data.message, "error");
                }
              });
          } else {
            Toast(data.message, "error");
          }
        })
        .catch((error) => {
          console.error("API call failed:", error);
          Toast("Something went wrong. Please try again.", "error");
          setIsLoading(false);
        });
    } else if (
      !props.location.state.ndaEnabled &&
      props.location.state.videoAcknowledgement
    ) {
      httpCommon
        .unsecuredAxios()
        .post("/web/questionariesAnswer", payload)
        .then((res) => {
          console.log("Health Questionaries added successfully", res.data);
        })
        .catch((error) => {
          console.error("API call failed:", error);
        });
      history.push({
        pathname: REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT,
        state: {
          code: props?.location?.state?.code,
          companyId: props?.location?.state?.companyId,
        },
      });
    } else if (props.location.state.ndaEnabled) {
      httpCommon
        .unsecuredAxios()
        .post("/web/questionariesAnswer", payload)
        .then((res) => {
          console.log("Health Questionaries added successfully", res.data);
        })
        .catch((error) => {
          console.error("API call failed:", error);
        });
      history.push({
        pathname: "/vis/VerifyNDA",
        state: {
          id: props.location.state.id,
          code: props.location.state.code,
          companyId: props.location.state.companyId,
          videoAcknowledgement: props?.location?.state?.videoAcknowledgement,
        },
      });
    } else {
      history.push("/vis/result-page");
    }

    setIsLoading(false);
  };

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
          backgroundColor: "#F4F6F8",
        }}
      >
        <Grid container alignItems="center">
          <Grid item className="logo-center">
            <img src={USA_visLogo} alt="logo" style={{ width: "180px" }} />
          </Grid>
        </Grid>
      </Grid>
      <Paper>
        <Typography
          gutterBottom
          variant="h3"
          style={{ padding: "25px", paddingLeft: "75px" }}
        >
          Checklist Form
        </Typography>
        <Grid container p={5} spacing={3}>
          <Grid item xs={12} sm={12}>
            <Grid container direction="row">
              {checkListItems.length > 0 &&
                checkListItems.map((checkList, index) => {
                  return (
                    <Grid item xs={12} sm={6} key={index}>
                      <Box
                        display="flex"
                        p={2}
                        marginLeft={"20px"}
                        marginRight={"20px"}
                      >
                        {index + 1 + ". "}{" "}
                        <FormControl component="fieldset">
                          <FormLabel
                            component="legend"
                            sx={{
                              color: "rgba(0, 0, 0, 0.6)",
                              "&.Mui-focused": {
                                color: "rgba(0, 0, 0, 0.6)",
                              },
                            }}
                          >
                            {checkList.question +
                              (checkList.mandatory !== "No" ? " *" : "")}
                          </FormLabel>

                          <RadioGroup
                            row
                            aria-label="options"
                            name={checkList.question}
                            value={
                              checkListAnswers.find(
                                (a) => a.Question === checkList.question,
                              )?.Answers || ""
                            }
                            onChange={handleChange}
                          >
                            {checkList?.options.map((data, optIndex) => {
                              const splittedData = data.split(",");
                              if (splittedData?.length > 0) {
                                return splittedData.map((option, i) => (
                                  <FormControlLabel
                                    key={`${index}-${optIndex}-${i}`}
                                    value={option}
                                    control={<Radio />}
                                    label={option}
                                  />
                                ));
                              }
                              return null;
                            })}
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>
        {isLoading ? (
          <Box sx={{ display: "flex" }} className="loader-container">
            <CircularProgress className="loader" />
          </Box>
        ) : (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Box display="flex" sx={{ m: 1 }}>
              <CancelButtons
                sx={{ m: 1 }}
                color="secondary"
                onClick={() => {
                  history.goBack();
                }}
                variant="contained"
              >
                <Typography>{"Back"}</Typography>
              </CancelButtons>
              <SubmitButtons
                sx={{ m: 1 }}
                onClick={handleSubmit}
                variant="contained"
              >
                <Typography>{t("CONTINUE_BUTTON")}</Typography>
              </SubmitButtons>
            </Box>
          </Grid>
        )}
      </Paper>
    </>
  );
}
export default ChecklistForm;
